import React, { lazy, Suspense } from "react";
import {
  BrowserRouter as Router,
  Route,
  Routes,
  Navigate,
} from "react-router-dom";
import Spinner from "react-bootstrap/Spinner";

import PrivateRoute from "./pages/PrivateRoute";

// Public routes
const Home = lazy(() => import("./components/app"));
const Login = lazy(() => import("./pages/Login"));
const VisaEnquiry = lazy(() => import("./pages/VisaEnquiry"));
const About = lazy(() => import("./layouts/About"));
const ViewOne = lazy(() => import("./pages/applications/ViewOne"));

// Private routes — only loaded when user is authenticated
const Dashboard = lazy(() => import("./pages/Dashboard"));
const Profile = lazy(() => import("./pages/profile/Profile"));
const UserManagement = lazy(
  () => import("./pages/userManagement/UserManagement"),
);
const AddUserManagement = lazy(
  () => import("./pages/userManagement/AddUserManagement"),
);
const EditUserManagement = lazy(
  () => import("./pages/userManagement/EditUserManagement"),
);
const ApplicationManagement = lazy(
  () => import("./pages/applications/ApplicationManagement"),
);
const AddUserApplication = lazy(
  () => import("./pages/applications/AddUserApplication"),
);
const EditApplication = lazy(
  () => import("./pages/applications/EditApplication"),
);
const UserView = lazy(() => import("./pages/applications/UserView"));
const SliderManagement = lazy(() => import("./pages/sliders/SliderManagement"));
const AddSlider = lazy(() => import("./pages/sliders/AddSlider"));
const EditSlider = lazy(() => import("./pages/sliders/EditSlider"));

const Fallback = (
  <div
    className="d-flex justify-content-center align-items-center"
    style={{ minHeight: "60vh" }}
  >
    <Spinner animation="border" variant="primary" />
  </div>
);

const App = () => {
  return (
    <Router>
      <Suspense fallback={Fallback}>
        <Routes>
          {/* Public Routes */}
          <Route path="/" element={<Home />} />
          <Route path="/login" element={<Login />} />
          <Route path="/enquiry" element={<VisaEnquiry />} />
          <Route path="/about" element={<About />} />
          <Route path="/profile" element={<Profile />} />
          <Route path="/view-one" element={<ViewOne />} />

          {/* Dashboard */}
          <Route
            path="/dashboard"
            element={
              <PrivateRoute>
                <Dashboard />
              </PrivateRoute>
            }
          />

          {/* User Management */}
          <Route
            path="/userManagement"
            element={
              <PrivateRoute>
                <UserManagement />
              </PrivateRoute>
            }
          />
          <Route
            path="/addUserManagement"
            element={
              <PrivateRoute>
                <AddUserManagement />
              </PrivateRoute>
            }
          />
          <Route
            path="/editUserManagement"
            element={
              <PrivateRoute>
                <EditUserManagement />
              </PrivateRoute>
            }
          />

          {/* Application Management */}
          <Route
            path="/application"
            element={
              <PrivateRoute>
                <ApplicationManagement />
              </PrivateRoute>
            }
          />
          <Route
            path="/addUserApplication"
            element={
              <PrivateRoute>
                <AddUserApplication />
              </PrivateRoute>
            }
          />
          <Route
            path="/editApplication"
            element={
              <PrivateRoute>
                <EditApplication />
              </PrivateRoute>
            }
          />
          <Route
            path="/userView/:id"
            element={
              <PrivateRoute>
                <UserView />
              </PrivateRoute>
            }
          />
          <Route
            path="/updateApplicationView/:id"
            element={
              <PrivateRoute>
                <UserView />
              </PrivateRoute>
            }
          />

          {/* Slider Management */}
          <Route
            path="/slider"
            element={
              <PrivateRoute>
                <SliderManagement />
              </PrivateRoute>
            }
          />
          <Route
            path="/addSliders"
            element={
              <PrivateRoute>
                <AddSlider />
              </PrivateRoute>
            }
          />
          <Route
            path="/editSlider"
            element={
              <PrivateRoute>
                <EditSlider />
              </PrivateRoute>
            }
          />

          {/* Catch-all */}
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </Suspense>
    </Router>
  );
};

export default App;
